import {
  FETCH_SIZES_REQUEST,
  FETCH_SIZES_SUCCESS,
  FETCH_SIZES_FAILURE,
  ADD_SIZE_REQUEST,
  ADD_SIZE_SUCCESS,
  ADD_SIZE_FAILURE,
  UPDATE_SIZE_REQUEST,
  UPDATE_SIZE_SUCCESS,
  UPDATE_SIZE_FAILURE,
  DELETE_SIZE_REQUEST,
  DELETE_SIZE_SUCCESS,
  DELETE_SIZE_FAILURE,
  SET_SIZE_EDIT,
  CLEAR_SIZE_EDIT,
} from '../../../../types/masters/styles/size/sizeTypes';
import {
  fetchSizes,
  addSize,
  updateSize,
  deleteSize,
} from '../../../../../api/masters/styles/size/sizeApi';

export const fetchSizesAction = () => async (dispatch) => {
  dispatch({ type: FETCH_SIZES_REQUEST });
  try {
    const data = await fetchSizes();
    dispatch({ type: FETCH_SIZES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_SIZES_FAILURE, payload: error.message });
  }
};

export const addSizeAction = (size) => async (dispatch) => {
  dispatch({ type: ADD_SIZE_REQUEST });
  try {
    await addSize(size);
    dispatch({ type: ADD_SIZE_SUCCESS });
    dispatch(fetchSizesAction());
  } catch (error) {
    dispatch({ type: ADD_SIZE_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateSizeAction = ({ id, size }) => async (dispatch) => {
  dispatch({ type: UPDATE_SIZE_REQUEST });
  try {
    const data = await updateSize(id, size);
    dispatch({ type: UPDATE_SIZE_SUCCESS, payload: data });
    dispatch(fetchSizesAction());
  } catch (error) {
    dispatch({ type: UPDATE_SIZE_FAILURE, payload: error.message });
    throw error;
  }
};

export const deleteSizeAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_SIZE_REQUEST });
  try {
    await deleteSize(id);
    dispatch({ type: DELETE_SIZE_SUCCESS, payload: id });
    dispatch(fetchSizesAction());
  } catch (error) {
    dispatch({ type: DELETE_SIZE_FAILURE, payload: error.message });
    throw error;
  }
};

export const setSizeEdit = (size) => ({
  type: SET_SIZE_EDIT,
  payload: size,
});

export const clearSizeEdit = () => ({
  type: CLEAR_SIZE_EDIT,
}); 